var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExtensionOptionEvent',{attrs:{"assetComponent":_vm.assetComponent,"form":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }